import { X } from "lucide-react";

export function Modal({ title, onClose, children, wide }) {
  const isLight = document.documentElement.getAttribute("data-theme") === "light";
  const bg = isLight ? "#ffffff" : "#1a1d23";
  const borderColor = isLight ? "rgba(0,0,0,0.12)" : "rgba(255,255,255,0.1)";
  const shadow = isLight ? "0 25px 50px rgba(0,0,0,0.15)" : "0 25px 50px rgba(0,0,0,0.5)";
  const overlay = isLight ? "rgba(0,0,0,0.4)" : "rgba(0,0,0,0.75)";
  const textColor = isLight ? "#1a1a2e" : "#fff";
  const mutedColor = isLight ? "rgba(0,0,0,0.4)" : "rgba(255,255,255,0.4)";

  return (
    <div className="apcs-modal-overlay" style={{ position: "fixed", inset: 0, zIndex: 50, display: "flex", alignItems: "center", justifyContent: "center", padding: 16, backgroundColor: overlay }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="apcs-modal-content" style={{ background: bg, border: `1px solid ${borderColor}`, borderRadius: 16, boxShadow: shadow, width: "100%", maxWidth: wide ? 900 : 640, maxHeight: "90vh", overflowY: "auto", color: textColor }}
        onClick={(e) => e.stopPropagation()}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: 20, borderBottom: `1px solid ${borderColor}` }}>
          <h3 style={{ fontSize: 18, fontWeight: 600, color: textColor, margin: 0 }}>{title}</h3>
          <button onClick={onClose} style={{ padding: 4, borderRadius: 8, border: "none", background: "none", cursor: "pointer", color: mutedColor, display: "flex" }}
            onMouseEnter={e => e.currentTarget.style.color = textColor}
            onMouseLeave={e => e.currentTarget.style.color = mutedColor}><X size={18} /></button>
        </div>
        <div style={{ padding: 20 }}>{children}</div>
      </div>
    </div>
  );
}
